import { ChildEntity } from '$/entities/BaseEntity';

import { PersonaIDVCheck as PersonaIDVCheckCommon } from '$/common/entities/tenantScreening/PersonaIDVCheck';
export *                                          from '$/common/entities/tenantScreening/PersonaIDVCheck';

@ChildEntity()
export class PersonaIDVCheck extends PersonaIDVCheckCommon {
}
